import domReady from '../helpers/dom-ready';

class ExhibitionAudio {
  static init() {
    return new ExhibitionAudio();
  }

  constructor() {
    const exhibitionHeader = document.querySelector('.exhibition-header');
    if (!exhibitionHeader) { return; }

    this.audio = exhibitionHeader.querySelector('.audio');
    if (!this.audio) { return; }

    this.viewOptions = exhibitionHeader.querySelector('.view-options');
    this.audioPlayer = exhibitionHeader.querySelector('.audio-player');
    this.openPlayerButton = exhibitionHeader.querySelector('.open-audio-player-button');
    this.closePlayerButton = exhibitionHeader.querySelector('.close-audio-player-button');
    this.playPauseButton = exhibitionHeader.querySelector('.play-pause-button');

    this.openSearchButton = exhibitionHeader.querySelector('.open-search-button');
    this.closeSearchButton = exhibitionHeader.querySelector('.close-search-button');

    this.audioPlayerIsVisible = false;
    this.hasAudioPlayed = false;

    this.addEventListeners();
  }

  addEventListeners() {
    this.openPlayerButton.addEventListener('click', () => {
      this.openAudioPlayer();
    });

    this.closePlayerButton.addEventListener('click', () => {
      this.closeAudioPlayer();
    });

    this.playPauseButton.addEventListener('click', () => {
      if (!this.audio.paused) {
        this.pauseAudio();
      } else {
        this.playAudio();
      }
    });

    this.audio.addEventListener('ended', () => {
      this.hasAudioPlayed = false;
      this.playPauseButton.classList.remove('-is-playing');
    });

    this.openSearchButton.addEventListener('click', () => {
      this.stopAudio();
      this.closeAudioPlayer();
    });

    window.addEventListener('keyup', (e) => { this.onKeyup(e); });
  }

  openAudioPlayer() {
    this.audioPlayerIsVisible = true;
    this.viewOptions.classList.add('-audio-player-active');
    this.audioPlayer.classList.remove('-hidden');
    this.playAudio();
  }

  closeAudioPlayer() {
    this.audioPlayerIsVisible = false;
    this.viewOptions.classList.remove('-audio-player-active');
    this.audioPlayer.classList.add('-hidden');
    this.stopAudio();
  }

  pauseAudio() {
    this.audio.pause();
    this.playPauseButton.setAttribute('aria-label', this.playPauseButton.dataset.playLabel);
    this.playPauseButton.classList.remove('-is-playing');
  }

  playAudio() {
    this.hasAudioPlayed = true;
    this.audio.play();
    this.playPauseButton.setAttribute('aria-label', this.playPauseButton.dataset.pauseLabel);
    this.playPauseButton.classList.add('-is-playing');
  }

  stopAudio() {
    this.hasAudioPlayed = false;
    this.audio.pause();
    this.audio.currentTime = 0;
    this.playPauseButton.classList.remove('-is-playing');
  }

  onKeyup(e) {
    if (e.key === 'Escape' && this.audioPlayerIsVisible) {
      this.stopAudio();
      this.closeAudioPlayer();
    }
  }
}

domReady(() => {
  ExhibitionAudio.init();
});
